export const LOGIN_USER = "LOGIN_USER";
export const REGISTER_USER = "REGISTER_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const UPDATE_USER_INFO = "UPDATE_USER_INFO";
export const UPDATE_USER_INFO_GENERAL = "UPDATE_USER_INFO_GENERAL";
export const SEND_OTP = "SEND_OTP";
export const VERIFY_OTP = "VERIFY_OTP";
export const RUNNING_ORDER = "RUNNING_ORDER";
export const GET_WALLET_TRANSACTIONS = "GET_WALLET_TRANSACTIONS";
